import React from 'react';
import { Layers, Zap } from 'lucide-react';

export type EditorMode = 'design' | 'processing';

interface ModeSelectorProps {
    currentMode: EditorMode;
    onModeChange: (mode: EditorMode) => void;
    className?: string;
}

export default function ModeSelector({
    currentMode,
    onModeChange,
    className = '',
}: ModeSelectorProps) {
    return (
        <div className={`flex bg-gray-100 rounded-lg p-1 ${className}`}>
            <button
                onClick={() => onModeChange('design')}
                className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
                    currentMode === 'design'
                        ? 'bg-white text-gray-900 shadow-sm'
                        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                }`}
            >
                <Layers className="w-4 h-4" />
                Design
            </button>
            <button
                onClick={() => onModeChange('processing')}
                className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
                    currentMode === 'processing'
                        ? 'bg-white text-gray-900 shadow-sm'
                        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                }`}
            >
                <Zap className="w-4 h-4" />
                Processing
            </button>
        </div>
    );
}
